import { useMemo } from "react";
import { useLang } from "@/lib/i18n";
import QuizEngine from "@/components/games/QuizEngine";

const SHAPES = [
  { id: "circle", en: "Circle", zh: "圆形", path: <circle cx="50" cy="50" r="38" /> },
  { id: "square", en: "Square", zh: "正方形", path: <rect x="14" y="14" width="72" height="72" rx="8" /> },
  { id: "triangle", en: "Triangle", zh: "三角形", path: <polygon points="50,12 88,86 12,86" /> },
  { id: "star", en: "Star", zh: "星形", path: <polygon points="50,8 61,38 93,38 67,58 77,90 50,70 23,90 33,58 7,38 39,38" /> },
  { id: "heart", en: "Heart", zh: "心形", path: <path d="M50 86 L18 54 C6 42 6 22 24 18 C36 15 46 24 50 32 C54 24 64 15 76 18 C94 22 94 42 82 54 Z" /> },
];
const COLORS = [
  { id: "blue", en: "Blue", zh: "蓝色", hex: "#147DEB" },
  { id: "yellow", en: "Yellow", zh: "黄色", hex: "#FFC928" },
  { id: "green", en: "Green", zh: "绿色", hex: "#45C878" },
  { id: "pink", en: "Pink", zh: "粉色", hex: "#FF91B8" },
];

function shuffle(a) {
  const arr = [...a];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function ShapeColorQuiz({ onFinish }) {
  const { code, t } = useLang();
  const questions = useMemo(() => {
    const rounds = [];
    for (let i = 0; i < 8; i++) {
      const shape = SHAPES[Math.floor(Math.random() * SHAPES.length)];
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      const askColor = i % 2 === 1;
      const pool = askColor ? COLORS : SHAPES;
      const correct = askColor ? color : shape;
      const distract = shuffle(pool.filter((x) => x.id !== correct.id)).slice(0, 2);
      const opts = shuffle([correct, ...distract]);
      rounds.push({
        promptNode: (
          <div>
            <svg viewBox="0 0 100 100" className="mx-auto h-28 w-28" fill={color.hex} aria-hidden="true">
              {shape.path}
            </svg>
            <p className="mt-3 text-center text-sm font-semibold text-[#64748B]">
              {askColor ? (code === "zh" ? "这是什么颜色？" : "What color is this?") : (code === "zh" ? "这是什么形状？" : "What shape is this?")}
            </p>
          </div>
        ),
        options: opts.map((o) => o[code]),
        answer: opts.findIndex((o) => o.id === correct.id),
      });
    }
    return rounds;
  }, [code]);
  void t;
  return <QuizEngine questions={questions} onFinish={onFinish} />;
}
